import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contentHeader flex" }
const _hoisted_2 = { class: "contentBox" }

import {onBeforeUnmount, ref} from "vue";
import TabsWrapper from "@/components/tabs/TabsWrapper.vue";
import TabItem from "@/components/tabs/TabItem.vue";
import FileTab from "@/components/tabs/dashboard/FileTab.vue";
import TicketTab from "@/components/tabs/dashboard/TicketTab.vue";
import {useGlobalStore} from "@/stores/GlobalStore";



export default /*#__PURE__*/_defineComponent({
  __name: 'Dashboard',
  setup(__props) {

const globalStore = useGlobalStore();
const activeTab = ref<number>(0);

onBeforeUnmount(()=>{
  globalStore.gridStore = null
  globalStore.gridColumnStore = null
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t('dashboard.title')), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TabsWrapper, { activeTab: activeTab.value }, {
        default: _withCtx(() => [
          _createVNode(TabItem, {
            title: _ctx.$t('dashboard.tabs.file.title')
          }, {
            default: _withCtx(() => [
              _createVNode(FileTab)
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(TabItem, {
            title: _ctx.$t('dashboard.tabs.ticket.title')
          }, {
            default: _withCtx(() => [
              _createVNode(TicketTab)
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _: 1
      }, 8, ["activeTab"])
    ])
  ], 64))
}
}

})